import React from 'react'
import { getCirclePositions } from '../globals'
import styled from 'styled-components'
import { IconCircle } from 'components/IconCircle'
const Container = styled.g``

export const VizElement = ({
  x = 0,
  y = 0,
  rad = 10,
  colors
}: {
  x?: number
  y?: number
  rad?: number

  colors: { [K in indicatorTypes]: string }
}) => {
  const circlePosition = getCirclePositions(rad)
  const scale = rad / 14
  return (
    <Container transform={`translate(${x},${y})`}>
      {circlePosition.map(prop => {
        if ((!prop.x && prop.x !== 0) || colors[prop.prop] === '#000')
          return null

        return (
          <IconCircle
            key={'VizElement_' + prop.prop}
            x={prop.x}
            y={prop.y}
            color={colors[prop.prop] || '#f8f8f8'}
            icon={prop.prop}
            rad={rad}
            iconScale={scale}
          />
        )
      })}
    </Container>
  )
}
